var config = process.server ? require('config') : {
  get: () => ''
};
export default {
  cdn: config.get('cdn'),
  web: config.get('web'),
  recaptcha: config.get('recaptcha'),
  catalog: config.get('proxy.catalog'),
  prismic: config.get('prismic'),
  graphqlExternal: config.get('graphql.external'),
  graphqlInternal: config.get('graphql.internal'),
  tracking: {
    container: config.get('tracking.container'),
    id: config.get('tracking.id'),
    checkout: {
      container: config.get('tracking.checkout.container'),
      id: config.get('tracking.checkout.id')
    }
  },
  oauth: {
    clientId: config.get('oauth.clientId'),
    redirectUri: config.get('oauth.redirectUri')
  },
  dalenys: config.get('dalenys'),
  gmaps: config.get('gmaps'),
  mercureDocument: config.get('mercureDocument'),
  gameId: config.get('gameId'),
  algolia: {
    applicationId: config.get('algolia.applicationId'),
    apiKey: config.get('algolia.apiKey'),
    indexName: config.get('algolia.indexName')
  },
  mdmToggleOpenFacets: config.get('mdmToggleOpenFacets')
};